import { render, staticRenderFns } from "./DairyItem.vue?vue&type=template&id=699d03cc&scoped=true&"
import script from "./DairyItem.vue?vue&type=script&lang=js&"
export * from "./DairyItem.vue?vue&type=script&lang=js&"
import style0 from "./DairyItem.vue?vue&type=style&index=0&id=699d03cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d03cc",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
